module.exports = __webpack_public_path__ + "media/images/hitfun/bg.prizehistory.certificate-3a8187f8f8e7cedc8a7b30e3552b4f5f.svg";